export const IMG_ADDED = 'IMG_ADDED'
export const IMG_REMOVED = 'IMG_REMOVED'
export const IMG_REPOSITIONED = 'IMG_REPOSITIONED'
export const IMG_RESCALED = 'IMG_RESCALED'
export const IMG_RESIZED = 'IMG_RESIZED'
export const IMG_ROTATED = 'IMG_ROTATED'
export const IMG_MIRRORED_X = 'IMG_MIRRORED_X'
export const IMG_MIRRORED_Y = 'IMG_MIRRORED_Y'
export const IMG_BRIGHTNESS_RESET = 'IMG_BRIGHTNESS_RESET'
export const IMG_ATTRIBUTES_UPDATED = 'IMG_ATTRIBUTES_UPDATED'
export const IMG_SENT_BACK = 'IMG_SENT_BACK'
export const IMG_SENT_FRONT = 'IMG_SENT_FRONT'

export type ImgHistoryItemAction =
  | typeof IMG_ADDED
  | typeof IMG_REMOVED
  | typeof IMG_REPOSITIONED
  | typeof IMG_RESCALED
  | typeof IMG_RESIZED
  | typeof IMG_ROTATED
  | typeof IMG_MIRRORED_Y
  | typeof IMG_MIRRORED_X
  | typeof IMG_BRIGHTNESS_RESET
  | typeof IMG_ATTRIBUTES_UPDATED
  | typeof IMG_SENT_BACK
  | typeof IMG_SENT_FRONT
